import { Pipe, PipeTransform } from '@angular/core';
import format from 'date-fns/format';
import addMinutes from 'date-fns/addMinutes';
import { CalendarService } from '@wfm/shared';

@Pipe({
  name: 'localToTimezone',
})
export class LocalToTimezonePipe implements PipeTransform {
  constructor(private calendarService: CalendarService) {}

  transform(date: Date, timezone: string, templateDate: string): string {
    const mskDate = this.calendarService.getUtcDate(date, 'Europe/Moscow');

    const realLocalTime = this.calendarService.userDateTime(mskDate, timezone);

    return format(addMinutes(realLocalTime, -realLocalTime.getTimezoneOffset()), templateDate);
  }
}
